import * as React from 'react'
import { Modal, Button } from 'react-bootstrap'
import OauthLoginForm from './OauthLoginForm'
import apiFetch, { initFetch } from './../common/apiFetch'
import { captureExceptionWithSentry } from '../sentry'

const OauthPermission: React.FunctionComponent = (props) => {
	const [token, setToken] = React.useState<string>('')
	const [callbackurl, setCallbackurl] = React.useState<string | null>('')
	const [clientId, setClientId] = React.useState<string | null>()
	const [clientName, setClientName] = React.useState<string | null>()
	const [state, setState] = React.useState<string | null>('')

	const handleToken = (token: string) => {
		setToken(token)
		handleGetPartnerInfo(token, clientId)
	}

	const searchParams = new URLSearchParams(window.location.search)
	React.useEffect(() => {
		const cid = searchParams.get('client_id')
		setCallbackurl(searchParams.get('callback_url'))
		setClientId(cid)
		setState(searchParams.get('state'))
	}, [searchParams])

	const handleGetPartnerInfo = async (authToken: string, cid: string | null | undefined) => {
		try {
			initFetch(authToken)
			const resp = await apiFetch(`/external/oauth/partnerinfo?client_id=${cid}`, {
				credentials: 'same-origin',
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				},
			})
			const result = await resp.json()
			setClientName(result.data[0]?.name)
		} catch (error) {
			captureExceptionWithSentry(error)
		}
	}

	const handlePermission = async () => {
		try {
			initFetch(token)
			const resp = await apiFetch(
				`/external/oauth/access/authentication?callback_url=${callbackurl}&client_id=${clientId}${state ? `&state=${state}` : ''
				}`,
				{
					credentials: 'same-origin',
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
					},
				},
			)
			const result = await resp.json()
			window.location.href = result.data
		} catch (error) {
			captureExceptionWithSentry(error)
		}
	}
	if (!token) {
		return <OauthLoginForm setUser={handleToken} />
	}

	const handleCancel = () => {
		window.location.href = `/oauth/permission?callback_url=${callbackurl}&client_id=${clientId}${state ? `&state=${state}` : ''
			}`
	}

	const style: React.CSSProperties = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: 'calc(100% - 60px)',
	}

	return (
		<div>
			<Modal
				{...props}
				bsSize="small"
				aria-labelledby="contained-modal-title-vcenter"
				dialogClassName="modal-dialog-centered"
				onHide={handleCancel}
				show={true}
				style={style}
			>
				<Modal.Header closeButton>
					<Modal.Title id="contained-modal-title-vcenter">Permission</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>Do you allow {clientName} to access all data of your clients and campaigns in Readpeak?</p>
				</Modal.Body>
				<Modal.Footer>
					<Button bsStyle="primary" bsSize="small" onClick={handlePermission}>
						Allow
					</Button>
					<Button bsStyle="default" bsSize="small" onClick={handleCancel}>
						Cancel
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	)
}

export default OauthPermission
